export default "__VITE_ASSET__GGXDzVZE__"